var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"facets"}},[_c('atomic-facet-manager',[_c('atomic-facet',{attrs:{"field":"publicationhubkeywords","label":"Keyword","display-values-as":"link"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba75f7fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/hcxf/hcxf-publication-facets.vue
// module id = 555
// module chunks = 0 1